import { curry, flowRight } from "lodash";
import type { CellProps, ListRow } from "app/pages/sales-intelligence/pages/home/types/table";
import type { QueryKey } from "@tanstack/react-query";
import withQueryDataCell from "../../../hoc/withQueryDataCell";
import withTrackedRedirectCell from "../../../hoc/withTrackedRedirectCell";
import { homePageQueryKeys } from "../../../services/queries/queryKeyFactory";

const getAssetsCountQueryKey = (props: CellProps<ListRow>): QueryKey => {
    return homePageQueryKeys.listAssetsCount(props.row.listId);
};

const withAssetsCountQueryData = curry(withQueryDataCell)(getAssetsCountQueryKey);

export const createCell = flowRight(withAssetsCountQueryData, withTrackedRedirectCell);
